module.exports = __webpack_public_path__ + "static/media/management-OA-02.02835aba.jpg";